import { PROOFPOINT_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const proofpointApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuarantinedEmails: builder.query({
            query: () => ({
                url: `${PROOFPOINT_URL}/quarantined`,
            }),
            keepUnusedDataFor: 5
        }),
    })
});

export const { useGetQuarantinedEmailsQuery } = proofpointApiSlice;
